export default __webpack_public_path__ + "static/media/coinbase.d68ae153.svg";